import { useState, useContext, useRef } from "react";
import { GenericList } from "../../../components";
import { dataType } from "../../../components/GenericList/GenericList";
import { BiTrash } from "react-icons/bi";
import { useRedirect } from "react-admin";
import { routePaths } from "../../../baseLayout/SidebarMenu";
import { APIContext } from "../../../store/APIStore";
import NotificationMessage, {
  notificationType,
} from "../../../components/NotificationMessage/NotificationMessage";
import { useHasPermissions } from "../../../hooks/useHasPermissions";
import { PERMISSIONS } from "../../../roles";


export interface IProps {
  eventId: number;
  sessionId: number;
  reservations: any[];
  onReservationListUpdate: Function; //callback to be called after every operation on reservations list
}

const ReservationsList = ({
  reservations,
  eventId,
  sessionId,
  onReservationListUpdate,
}: IProps) => {
  // const classes = useStyles();
  const [dataLoading,] = useState(false);
  const api = useContext(APIContext);
  const redirect = useRedirect();
  const notificationRef = useRef<any>();

  // permissions
  const canManageReservation = useHasPermissions(
    PERMISSIONS.CAN_MANAGE_RESERVATION
  );

  const handleDeleteReservation = async (attendeeId: number) => {
    try {
      await api.attendeeService.removeReservation(
        attendeeId,
        eventId,
        sessionId
      );
      onReservationListUpdate(
        "Reservation successfully deleted",
        notificationType.Success
      );
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const handleBulkDelete = async (items: number[]) => {
    try {
      await Promise.all(
        items.map((item) => {
          return api.attendeeService.removeReservation(
            item,
            eventId,
            sessionId
          );
        })
      );
      onReservationListUpdate(
        "Reservations successfully deleted",
        notificationType.Success
      );
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  // const handleDeleteAll = async () => {
  //   // TODO integrate delete all reservations endpoint
  //   try {
  //   } catch (error: any) {
  //     console.log(error.response);
  //     notificationRef.current?.show(
  //       error.response.data.message,
  //       notificationType.Error
  //     );
  //   }
  // };

  const bulkActions = [
    {
      label: "Delete",
      key: "delete",
      callback: handleBulkDelete,
      startIcon: <BiTrash />,
    },
  ];

  // actions shown on top right
  // const customActions = [
  //   {
  //     label: "Delete all",
  //     key: "delete-all",
  //     callback: handleDeleteAll,
  //     startIcon: <BiTrash />,
  //   },
  // ];

  return (
    <>
      <GenericList
        type={dataType.RESERVATIONS}
        items={reservations}
        onDeleteItem={
          canManageReservation ? handleDeleteReservation : undefined
        }
        style={{ width: "100%" }}
        onSelectItem={(item: any) => {
          redirect(
            `/${routePaths.EVENTS}/${eventId}/${routePaths.SESSIONS}/${sessionId}/${routePaths.RESERVATIONS}/${item.id}/${routePaths.EDIT}`
          );
        }}
        isLoading={dataLoading}
        bulkActions={canManageReservation ? bulkActions : undefined}
        // customActions={canManageReservation ? customActions : undefined}
      />

      <NotificationMessage ref={notificationRef} />
    </>
  );
};

export default ReservationsList;
